import React, { useState, useEffect } from "react";

const apiBase = "/api/home/uploads?type=";
const tabTypes = [
  { key: "Notice", label: "Notice" },
  { key: "Referee", label: "Referee" },
  { key: "Circular", label: "Circular" },
  { key: "Others", label: "Others" },
];

export default function FlashUpdatesSection() {
  const [activeTab, setActiveTab] = useState("Notice");
  const [tabData, setTabData] = useState({});
  const [loading, setLoading] = useState({});
  const [error, setError] = useState({});

  useEffect(() => {
    if (!tabData[activeTab]) {
      setLoading(l => ({ ...l, [activeTab]: true }));
      fetch(apiBase + activeTab)
        .then(r => {
          if (!r.ok) throw new Error("Failed to fetch " + activeTab);
          return r.json();
        })
        .then(data => {
          setTabData(d => ({ ...d, [activeTab]: data }));
          setLoading(l => ({ ...l, [activeTab]: false }));
        })
        .catch(e => {
          setError(er => ({ ...er, [activeTab]: e.message }));
          setLoading(l => ({ ...l, [activeTab]: false }));
        });
    }
  }, [activeTab, tabData]);

  return (
    <section id="video" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="wow fadeInUp col-md-12" data-wow-delay="0.6s">
            <h2 className="text-center">Flash Updates</h2>
            <ul className="nav nav-tabs nav-justified" role="tablist">
              {tabTypes.map(tab => (
                <li key={tab.key} className={activeTab === tab.key ? "active" : ""}>
                  <a
                    href={"#" + tab.key.toLowerCase()}
                    role="tab"
                    data-toggle="tab"
                    onClick={e => {
                      e.preventDefault();
                      setActiveTab(tab.key);
                    }}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="tab-content" style={{ marginTop: 20 }}>
              {tabTypes.map(tab => (
                <div
                  key={tab.key}
                  className={`tab-pane fade${activeTab === tab.key ? " in active" : ""}`}
                  id={tab.key.toLowerCase()}
                >
                  {loading[tab.key] && <div>Loading {tab.label}...</div>}
                  {error[tab.key] && <div style={{ color: "red" }}>{error[tab.key]}</div>}
                  {!loading[tab.key] && !error[tab.key] && tabData[tab.key] && (
                    <div className="well">
                      <h4>
                        {tab.key === "Notice" && "📢 Latest Notices"}
                        {tab.key === "Referee" && "🏅 Referee Instructions"}
                        {tab.key === "Circular" && "📝 Circulars"}
                        {tab.key === "Others" && "🔔 Other Announcements"}
                      </h4>
                      <ul>
                        {tabData[tab.key].length === 0 && (
                          <li>No updates available.</li>
                        )}
                        {tabData[tab.key].map(item => (
                          <li key={item.id}>
                            {item.pathUrl ? (
                              <a
                                href={item.pathUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item.remark}
                              </a>
                            ) : (
                              item.remark
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
